module.exports = __webpack_public_path__ + "static/media/instagram_icon.92c207d0.svg";